/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: "edit-payout-form",
  formField: {
    paid_at: {
      name: "paid_at",
      label: "Fecha de Pago",
      type: "date",
      options: {
        enableTime: false,
        disableMobile: true,
        dateFormat: 'Y-m-d'
      },
      errorMsg: "La fecha de pago es obligatoria.",
    },
    voucher: {
      name: "voucher",
      label: "Comprobante",
      type: "file",
      accept: {
        'image/png': ['.png'],
        'image/jpg': ['.jpg'],
        'image/jpeg': ['.jpeg'],
      },
      fileType: "image"
    },
  },
};

export default form;
